import React, { useState } from 'react';
import { RxCross1 } from "react-icons/rx";
import { isMobile } from "react-device-detect";

const SubscriptionConsentDialog = ({
  isOpen,
  onClose,
  consentText,
  onAgree,
  buttonText = "Agree",
  contactUsLink = "mailto:support@chefrepublic.us"
}) => {
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  // Styles object with improvements
  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(4px)',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
    dialog: {
      width: isMobile ? '90%' : '600px',
      maxHeight: '90vh',
      backgroundColor: '#FAFAFA',
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      padding: '24px',
      overflow: 'auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '16px',
    },
    closeButton: {
      width: '32px',          // Slightly larger for better tap area
      height: '32px',
      backgroundColor: '#FF5E41',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      border: 'none',
      padding: 0,              // Remove any default padding
      transition: 'background-color 0.2s',
      // Hover effect (can be added via CSS class, but inline we can't; user can add class)
    },
    closeIcon: {
      color: '#ffffff',
      fontSize: '18px',        // Slightly larger to fill the circle
      lineHeight: 1,           // Prevent extra vertical space
      display: 'flex',         // Ensure the icon itself is a flex container
      alignItems: 'center',
      justifyContent: 'center',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      fontSize: '14px',
      color: '#000',
      lineHeight: 1.6,
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '24px',
      gap: '12px',
    },
    checkbox: {
      width: '20px',
      height: '20px',
      marginTop: '2px',
      cursor: 'pointer',
      accentColor: '#FF5E41',
    },
    consentText: {
      flex: 1,
      whiteSpace: 'pre-line',
    },
    agreeButton: {
      border: 'none',
      padding: '12px 24px',
      width: '200px',
      backgroundColor: isChecked ? '#FF5E41' : '#D3D3D3',
      borderRadius: '30px',    // More modern rounded button
      color: '#ffffff',
      textAlign: 'center',
      marginTop: '8px',
      cursor: isChecked ? 'pointer' : 'not-allowed',
      alignSelf: 'center',
      fontSize: '16px',
      fontWeight: '500',
      transition: 'background-color 0.3s, transform 0.1s',
      // Optional hover effect when enabled
      ...(isChecked && {
        ':hover': {
          backgroundColor: '#e04e32', // Darker shade on hover (inline can't do pseudo, but you can add class)
        }
      }),
    },
    contactLink: {
      color: '#FF5E41',
      textDecoration: 'underline',
      cursor: 'pointer',
      textAlign: 'center',
      marginTop: '16px',
      fontSize: '14px',
    },
  };

  const handleAgree = () => {
    if (isChecked && onAgree) {
      onAgree();
    }
  };

  const handleContactUs = (e) => {
    e.preventDefault();      // Prevent any default action if this were a link
    e.stopPropagation();     // Prevent the overlay click from closing the dialog
    window.location.href = contactUsLink; // Redirect to mail client
  };

  return (
    <div style={styles.overlay} onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <div style={styles.dialog}>
        <div style={styles.header}>
          <button
            style={styles.closeButton}
            onClick={onClose}
            aria-label="Close dialog"
            // Add a hover effect via onMouseEnter/Leave if needed, but inline pseudo not possible
          >
            <span style={styles.closeIcon}>
              <RxCross1 />
            </span>
          </button>
        </div>
        <div style={styles.body}>
          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              id="consent-checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              style={styles.checkbox}
            />
            <label htmlFor="consent-checkbox" style={styles.consentText}>
              {consentText}
            </label>
          </div>
          <button
            style={styles.agreeButton}
            onClick={handleAgree}
            disabled={!isChecked}
          >
            {buttonText}
          </button>
          <div
            style={styles.contactLink}
            onClick={handleContactUs}
            role="link"
            tabIndex={0}
          >
            Contact Us
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionConsentDialog;